import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=8f20ff10&scoped=true"
import script from "./user-card.vue?vue&type=script&lang=js"
export * from "./user-card.vue?vue&type=script&lang=js"
import style0 from "./user-card.vue?vue&type=style&index=0&id=8f20ff10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f20ff10",
  null
  
)

export default component.exports